export const useInstallationName = (str, installationName) => {
  if (str && installationName) {
    return str.replace(/C3/g, installationName);
  }
  return str;
};

export default {
  methods: {
    useInstallationName,
  },
};
